module.exports = __webpack_public_path__ + "img/je.42fa0643.svg";